import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './MainPage/main/main.component';
import { TestCentersComponent } from './MainPage/navigation/test-centers/test-centers.component';
import { AllTestsComponent } from './Tests/all-tests/all-tests.component';
import { ProductComponent } from './Tests/product/product.component';
import { CategoryComponent } from './Tests/category/category.component';
import { UserCabinetComponent } from './UserCabinet/user-cabinet/user-cabinet.component';
import { SearchResultsComponent } from './Tests/search-results/search-results.component';
import { CheckoutComponent } from './MainPage/checkout/checkout.component';
import { DynamicContentComponent } from './MainPage/navigation/dynamic-content/dynamic-content.component';
import { LoginAsComponent } from './Admin/login-as/login-as.component';
import { LoginAsGuard } from './Admin/login-as/login-as.guard';
import { ConfirmEmailComponent } from './Modals/confirm-email/confirm-email.component';

const routes: Routes = [
  {
    path: 'blog',
    loadChildren: () => import('./Blog/blog.module').then(m => m.BlogModule)
  },
  {
    path: '',
    component: MainComponent
  },
  {
    path: 'all/:panels',
    loadChildren: () => import('./MainPage/navigation/catalog.module').then(m => m.CatalogModule)
  },
  {
    path: 'category/:id',
    loadChildren: () => import('./MainPage/navigation/catalog.module').then(m => m.CatalogModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./Admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'product/:id',
    loadChildren: () => import('./MainPage/navigation/catalog.module').then(m => m.CatalogModule)
  },
  {
    path: 'product/:id/promocode/:code',
    loadChildren: () => import('./MainPage/navigation/catalog.module').then(m => m.CatalogModule)
  },
  {
    path: 'testcenters',
    component: TestCentersComponent
  }, {
    path: 'ResetPassword',
    component: MainComponent
  }, {
    path: 'cart',
    loadChildren: () => import('./MainPage/cart/cart.module').then(m => m.CartModule)
  },
  // {
  //   path: 'dashboard/users',
  //   component: AdminUsersComponent
  // },
  {
    path: 'all', // Також частина каталогу
    loadChildren: () => import('./MainPage/navigation/catalog.module').then(m => m.CatalogModule)
  },
  {
    path: '',
    canActivate: [LoginAsGuard],
    component: LoginAsComponent
  }, {
    path: 'auth',
    canActivate: [LoginAsGuard],
    component: LoginAsComponent
  }, {
    path: 'account',
    component: UserCabinetComponent
  }, {
    path: 'cabinet',
    redirectTo: 'account', pathMatch: 'full'
  },
  {
    path: 'search/:text',
    loadChildren: () => import('./MainPage/navigation/catalog.module').then(m => m.CatalogModule)
  },
  {
    path: 'checkout',
    component: CheckoutComponent
  }, {
    path: 'confirm/:user/:security',
    component: ConfirmEmailComponent
  }, {
    path: 'promocode/:code',
    component: MainComponent
  }, {
    path: 'disableNonTransactionalEmails',
    component: MainComponent
  }, {
    path: '**',
    component: DynamicContentComponent
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
